package one.healthium.onboarding.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Slide(
    @SerialName("title") val title: String?,
    @SerialName("image") val image: String?,
    @SerialName("time_code") val timeCode: Float,
)